// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2xBpP","modalForm":"UpgradeEpcsModal_modalForm__ZoIpO","modalFooter":"UpgradeEpcsModal_modalFooter__8ydmD"};